import React from "react";
import { useParams } from "react-router";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { isAnyRDT, isCoworkerHubRDT } from "@coworker/reusable/helpers/devices";
import {
  isDesktop,
  isBarcodeDetectorSupported,
} from "./defaultScannerPageUtils";

const DefaultScannerPage: React.FC = () => {
  const navigate = useFixaNavigate();
  const isBarcodeDetectorAvailable = isBarcodeDetectorSupported();
  const { type } = useParams<{ type: string }>();

  React.useEffect(() => {
    if (isDesktop()) {
      navigate(`/product-search/${type}`);
    } else if (isCoworkerHubRDT()) {
      navigate(`/scanner/cwh/${type}`, { replace: true });
    } else if (isAnyRDT()) {
      navigate(`/scanner/hdi/${type}`, { replace: true });
    } else if (isBarcodeDetectorAvailable) {
      navigate(`/scanner/camera/${type}`, { replace: true });
    } else {
      navigate(`/product-search/${type}`);
    }
  }, [type, navigate, isBarcodeDetectorAvailable]);
  // This component is a redirector, it does not render anything itself.
  return null;
};

export default DefaultScannerPage;
